
import Async from "../../components/Async";

import { More, Send, ViewCarousel } from "@material-ui/icons";
import { Book } from "@material-ui/icons";
import WhatsappCampaignMetricsPage from "../../pages/marketing/whatsapp/whatsappCampaigns/whatsapp.campaign.metrics.page";

const AuthGuard = Async(() => import('../auth.guard'));

const WhatsappNotificationsPage = Async(() => import('../../pages/marketing/whatsapp/whatsappNotificationsPage'));
const WhatsappAutomationPage = Async(() => import('../../pages/marketing/whatsapp/whatsappAutomationPage'));
const Automations = Async(() => import('../../pages/marketing/automations/automations'));
const BlogPage = Async(() => import("../../pages/marketing/blog/blogPage"));
const Banner = Async(() => import('../../pages/marketing/banners/banners'));
const VoucherView = Async(() => import("../../pages/marketing/voucher.table"));
const WhatsappNotificationDetailPage = Async(() => import('../../pages/marketing/whatsapp/whatsappNotificationDetails/whatsappNotificationDetailPage'));
const WhatsappCreateCampaignPage = Async(() => import('../../pages/marketing/whatsapp/whatsappCampaigns/whatsappCreateCampaignPage'));
const WhatsappCampaignsPage = Async(() => import('../../pages/marketing/whatsapp/whatsappCampaigns/whatsappCampaignsPage'));
const EmailCampaigns = Async(() => import('../../pages/marketing/email/email.campaigns'));
const BannerEditor = Async(() => import('../../pages/marketing/banners/banner.editor'));

const routes = {
    notifications: {
        id: 'Marketing',
        path: '/marketing',
        icon: <Send />,
        children: [
            {
                id: 'blog',
                name: 'Blog',
                path: '/blog',
                component: BlogPage,
                icon: <Book />,
                roles: ['admin'],
            },
            {
                id: 'banners',
                name: 'Banners',
                icon: <ViewCarousel />,
                path: '/marketing/banners',
                component: Banner,
                roles: ['admin', 'email'],
            },
            {
                id: 'campaigns',
                path: '/marketing/email/campaigns',
                name: 'Campanha de Email',
                component: EmailCampaigns,
                roles: ['admin', 'email'],
            },
            {
                id: 'whatsappCampaigns',
                path: '/marketing/whatsapp/campaigns',
                name: 'Campanha de WhatsApp',
                component: WhatsappCampaignsPage,
                roles: ['admin', 'email'],
            },
            {
                id: 'automations',
                path: '/marketing/automations',
                name: 'Automações',
                component: Automations,
                roles: ['admin', 'email'],
            },
            {
                id: 'whatsapp',
                path: '/marketing/whatsapp/notifications',
                name: 'WhatsApp',
                component: WhatsappNotificationsPage,
                roles: ['admin'],
                isNew: true,
            },
            {
                id: 'vouchers',
                name: 'Vouchers',
                path: '/marketing/vouchers',
                component: VoucherView,
                icon: <More />,
                roles: ['admin', 'financial', 'marketing'],
            },
        ],
        component: null,
        roles: ['admin', 'financial', 'marketing', 'email'],
    },
    bannerCreation: {
        id: 'bannerCreation',
        path: '/marketing/banners/editor',
        component: BannerEditor,
        roles: ['admin', 'marketing'],
    },
    bannerEditor: {
        id: 'bannerEditor',
        path: '/marketing/banners/editor/:id',
        component: BannerEditor,
        roles: ['admin', 'marketing'],
    },
    leadsAutomation: {
        id: 'leadsAutomation',
        path: '/marketing/whatsapp/leads-automation',
        name: 'Automação de Leads',
        component: WhatsappAutomationPage,
        guard: AuthGuard,
        roles: ['admin', 'marketing'],
    },
    whatsappNotificationCreation: {
        id: 'whatsappNotificationCreation',
        path: '/marketing/whatsapp/notifications/editor',
        component: WhatsappNotificationDetailPage,
        roles: ['admin', 'marketing'],
    },
    whatsappNotificationDetail: {
        id: 'whatsappNotificationDetail',
        path: '/marketing/whatsapp/notifications/editor/:id',
        component: WhatsappNotificationDetailPage,
        roles: ['admin', 'marketing'],
    },
    whatsappCreateCampaign: {
        id: 'whatsappCreateCampaign',
        path: '/marketing/whatsapp/campaigns/editor/',
        component: WhatsappCreateCampaignPage,
        roles: ['admin', 'marketing'],
    },
    whatsappEditCampaign: {
        id: 'whatsappEditCampaign',
        path: '/marketing/whatsapp/campaigns/details/:id',
        component: WhatsappCreateCampaignPage,
        roles: ['admin', 'marketing'],
    },
    whatsappCampaignMetrics: {
        id: 'whatsappCampaignMetrics',
        path: '/marketing/whatsapp/campaigns/metrics/:id',
        component: WhatsappCampaignMetricsPage,
        roles: ['admin', 'marketing'],
    },
}

const pages = Object.values(routes);

export default {
    routes,
    pages,
}